import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IDeleteEntity, IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';
import { IServiceItem, ITask, IUserGroup } from '../lookups';
import { SessionDates } from './SessionDates';
import { ContractCumulative } from './store/contract-cumulative.model';
import { Users } from './store/users.model';
import { CumulativeUpload } from '../data-services/cumulative-upload/cumulative-upload.model';

@Injectable({
    providedIn: 'root'
})
export class ContractCumulativeService {
    constructor(private http: HttpClient, private log: LoggingService) {}

    private uploadUri = `${environment.apiLocation}/CumulativeUpload`;
    private uri = `${environment.apiLocation}/ContractCum`;
    private getUri = `${environment.apiLocation}/ContractCum?Commit=True`;
    private userUri = `${environment.apiLocation}/User`;
    private sessionUri = `${environment.apiLocation}/EFSession/?SessionType=C`;

    public getSessionDates(): Observable<Array<SessionDates>> {
        this.log.verbose({
            type: 'ContractCumulativeService:getSessionDates',
            uri: this.sessionUri
        });
        return this.http.get<Array<SessionDates>>(this.sessionUri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'ContractCumulativeService:response',
                    res
                })
            )
        );
    }

    public postContractCums(
        DirectOrIndirect: string,
        Todayonly: boolean,
        Asofdate: Date,
        Tasks: ITask[],
        ServiceItems: IServiceItem[],
        DirectReports: Users[],
        Txntype: string,
        CostCenters: IUserGroup[]
    ): Observable<Array<ContractCumulative>> {
        this.log.verbose({
            type: 'ContractCumulativeService:postContractCums',
            uri: this.uri
        });
        return this.http
            .post<Array<ContractCumulative>>(this.uri, {
                DirectOrIndirect: DirectOrIndirect,
                Todayonly: Todayonly,
                Asofdate: Asofdate,
                Tasks: Tasks,
                ServiceItems: ServiceItems,
                DirectReports: DirectReports,
                Txntype: Txntype,
                CostCenters: CostCenters
            })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'ContractCumulativeService:response',
                        res
                    })
                )
            );
    }

    public uploadCumulatives(JsonString: string): Observable<any> {
        this.log.verbose({
            type: 'ContractCumulativeService:uploadCumulatives',
            uri: this.uri
        });
        return this.http
            .post<any>(this.uploadUri, {
                JsonString: JsonString
            })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'ContractCumulativeService:response',
                        res
                    })
                )
            );
    }

    public getContractCums(): Observable<Array<ContractCumulative>> {
        this.log.verbose({
            type: 'ContractCumulativeService:getContractCums',
            uri: this.getUri
        });
        return this.http.get<Array<ContractCumulative>>(this.getUri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'ContractCumulativeService:response',
                    res
                })
            )
        );
    }

    public putContractCums(
        contractcums: Array<ContractCumulative>
    ): Observable<IGenericResponse<ContractCumulative>> {
        return this.http
            .put<IGenericResponse<ContractCumulative>>(this.uri, {
                ContractCumList: contractcums
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'ContractCumulativeService:putContractCums',
                        data
                    })
                )
            );
    }

    public deleteContractCum(ids: Array<string>) {
        return this.http
            .request<IGenericResponse<IDeleteEntity>>('DELETE', this.uri, {
                body: { EntityIDs: ids }
            })
            .pipe(
                tap(data => {
                    this.log.verbose({
                        type: 'ContractCumulativeService:deleteContractCum:reponse',
                        data
                    });
                })
            );
    }

    public getUsers(UserFilterID: number, ShowInactive: boolean) {
        return this.http
            .post<Array<Users>>(this.userUri, {
                UserFilterID: UserFilterID,
                ShowInactive: ShowInactive
            })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'ContractCumulativeService:response',
                        res
                    })
                )
            );
    }
}
